/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_20_TitleInputs */

const en_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginkgo`)
};

const ar_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جنكو`)
};

const de_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginkgo`)
};

const es_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginkgo`)
};

const fr_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginkgo`)
};

const it_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginkgo`)
};

const ja_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イチョウ`)
};

const ko_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`은행 나무`)
};

const pt_br_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginkgo`)
};

const ru_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гинкго`)
};

const th_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นแปะก๊วย`)
};

const tr_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabet Ağacı`)
};

const zh_cn_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`银杏`)
};

const zh_tw_tree_type_20_title = /** @type {(inputs: Tree_Type_20_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銀杏`)
};

/**
* | output |
* | --- |
* | "Ginkgo" |
*
* @param {Tree_Type_20_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_20_title = /** @type {((inputs?: Tree_Type_20_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_20_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_20_title(inputs)
	if (locale === "ar") return ar_tree_type_20_title(inputs)
	if (locale === "de") return de_tree_type_20_title(inputs)
	if (locale === "es") return es_tree_type_20_title(inputs)
	if (locale === "fr") return fr_tree_type_20_title(inputs)
	if (locale === "it") return it_tree_type_20_title(inputs)
	if (locale === "ja") return ja_tree_type_20_title(inputs)
	if (locale === "ko") return ko_tree_type_20_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_20_title(inputs)
	if (locale === "ru") return ru_tree_type_20_title(inputs)
	if (locale === "th") return th_tree_type_20_title(inputs)
	if (locale === "tr") return tr_tree_type_20_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_20_title(inputs)
	return zh_tw_tree_type_20_title(inputs)
});